export const FETCH_NOTIFICATION_FAIL = '[Notification] FETCH_NOTIFICATION_FAIL';
export const SET_NOTIFICATION = '[Notification] SET_NOTIFICATION';
export const PATCH_NOTIFICATION = '[Notification] PATCH_NOTIFICATION';
export const PATCH_NOTIFICATION_FAIL = '[Notification] PATCH_NOTIFICATION_FAIL';
